import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import BrandMark from "@/components/BrandMark";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Projects from "@/components/Projects";
import QuoteForm from "@/components/QuoteForm";
import Footer from "@/components/Footer";

export default function Home() {
  return (
    <main className="relative" data-testid="home-page">
      <Nav />
      <Hero />
      <BrandMark />
      <Marquee />
      <Manifesto />
      <Services />
      <Projects />
      <QuoteForm />
      <Footer />
    </main>
  );
}
